// ===== UNOO VIRTUAL SHOPPING =====

document.addEventListener('DOMContentLoaded', function () {

  const vsRoot = document.querySelector('.unoo-vs-page') || document;

  // ===== FAQ ACCORDION =====
  vsRoot.querySelectorAll('.unoo-vs-faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const answer = btn.nextElementSibling;
      const chevron = btn.querySelector('.unoo-vs-faq-chevron');
      const isOpen = answer.classList.contains('unoo-vs-open');

      // close all
      vsRoot.querySelectorAll('.unoo-vs-faq-answer').forEach(function (a) {
        a.classList.remove('unoo-vs-open');
      });
      vsRoot.querySelectorAll('.unoo-vs-faq-chevron').forEach(function (c) {
        c.classList.remove('unoo-vs-open');
      });

      if (!isOpen) {
        answer.classList.add('unoo-vs-open');
        chevron.classList.add('unoo-vs-open');
      }
    });
  });

  // ===== MODAL =====
  var modal = document.getElementById('unoo-vs-modal');
  var modalServiceName = document.getElementById('unoo-vs-modal-service-name');
  var modalCreditNote = document.getElementById('unoo-vs-modal-credit-note');

  function unooVsOpenModal(title, price) {
    modalServiceName.textContent = title;
    modalCreditNote.textContent = price > 0
      ? 'Your $' + price + ' credit is activated upon session confirmation.'
      : 'Our 5-minute introduction sessions are complimentary.';
    modal.classList.add('unoo-vs-open');
    document.body.style.overflow = 'hidden';
  }

  function unooVsCloseModal() {
    modal.classList.remove('unoo-vs-open');
    document.body.style.overflow = '';
  }

  vsRoot.querySelectorAll('[data-book]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      unooVsOpenModal(btn.dataset.title, parseInt(btn.dataset.price, 10));
    });
  });

  // ===== CREDIT CARDS =====
  vsRoot.querySelectorAll('.unoo-vs-credit-card').forEach(function (card) {
    card.style.cursor = 'pointer';
    card.addEventListener('click', function () {
      var amount = card.querySelector('.unoo-vs-credit-amount').textContent.replace('$', '');
      var label = card.querySelector('.unoo-vs-credit-label').textContent;
      unooVsOpenModal(label, parseInt(amount, 10));
    });
  });

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) unooVsCloseModal();
    });
  }

  var modalClose = document.getElementById('unoo-vs-modal-close');
  if (modalClose) {
    modalClose.addEventListener('click', unooVsCloseModal);
  }

  // ===== SMOOTH SCROLL =====
  var heroCta = document.getElementById('unoo-vs-hero-cta');
  if (heroCta) {
    heroCta.addEventListener('click', function () {
      var target = document.getElementById('unoo-vs-how-it-works');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  }

});
